import React from 'react';
import { ALLOWANCE_STATUS } from '@blink/components/src/types';
import { ReactComponent as SuccessAllowanceIcon } from '@blink/assets/src/icons/succesAllowance.svg';
import { ReactComponent as CautionIcon } from '@blink/assets/src/icons/warningNotFilled.svg';
import { ReactComponent as ErrorIcon } from '@blink/assets/src/icons/alert.svg';
import { ReactComponent as AwaitIcon } from '@blink/assets/src/icons/lock-open-notFilled.svg';
import { ReactComponent as LoadingIcon } from '@blink/assets/src/icons/loadingCircle.svg';

type StatusType = {
    status: ALLOWANCE_STATUS;
};

export const StatusCaution = () => {
    return (
        <div
            className='
                flex justify-center items-center 
                rounded-sm 
                py-2 px-3 
                min-w-[80px] 
                font-semibold text-sm 
                bg-background-yellow50 text-content-yellow800 
                [&>svg]:mr-3 [&>svg]:w-5 [&>svg]:h-5 
                [&_path]:fill-content-yellow800
            '
        >
            <CautionIcon /> Caution
        </div>
    );
};

export const StatusDone = () => {
    return (
        <div
            className='
                flex justify-center items-center 
                rounded-sm 
                py-2 px-3 
                min-w-[80px] 
                font-semibold text-sm 
                bg-background-green50 text-content-green800 
                [&>svg]:mr-3 [&>svg]:w-5 [&>svg]:h-5 
                [&_path]:fill-content-green800
                [&_svg]:fill-current [&_svg]:text-content-green800
            '
        >
            <SuccessAllowanceIcon /> Done
        </div>
    );
};

export const StatusFailed = () => {
    return (
        <div
            className='
                flex justify-center items-center 
                rounded-sm 
                py-2 px-3 
                min-w-[80px] 
                font-semibold text-sm 
                bg-background-lightNegative text-content-negative 
                [&>svg]:mr-3 [&>svg]:w-5 [&>svg]:h-5 
                [&>svg>path]:fill-content-negative
            '
        >
            <ErrorIcon /> Failed
        </div>
    );
};

export const StatusProcessing = () => {
    return (
        <div
            className='
                flex justify-center items-center 
                rounded-sm 
                py-2 px-3 
                min-w-[80px] 
                font-semibold text-sm 
                bg-background-brand50 text-content-brand500 
                [&>svg]:mr-3 [&>svg]:w-5 [&>svg]:h-5 
                [&>svg>path]:fill-content-accent
            '
        >
            <LoadingIcon className='rotate-180 w-5 h-5' />
            Ongoing
        </div>
    );
};

export const StatusWaiting = () => {
    return (
        <div
            className='
                flex justify-center items-center 
                rounded-sm 
                py-2 px-3 
                min-w-[80px] 
                font-semibold text-sm 
                bg-background-yellow50 text-content-yellow800 
                [&>svg]:mr-3 [&>svg]:w-5 [&>svg]:h-5 
                [&_path]:fill-content-yellow800
                [&_svg]:fill-current [&_svg]:text-content-yellow800
            '
        >
            <AwaitIcon />
            Awaiting
        </div>
    );
};

export const STATUSES = new Map()
    .set(ALLOWANCE_STATUS.SUCCESS, <StatusDone />)
    .set(ALLOWANCE_STATUS.ERROR, <StatusFailed />)
    .set(ALLOWANCE_STATUS.PROCESSING, <StatusProcessing />)
    .set(ALLOWANCE_STATUS.WAITING, <StatusWaiting />)
    .set(ALLOWANCE_STATUS.WARNING, <StatusCaution />);

export const Status = ({ status }: StatusType) => {
    const statusComponent = STATUSES.has(status) ? STATUSES.get(status) : null;
    return <div>{statusComponent}</div>;
};
